<template>
    <div class="register">
        <div class="box-card">
            <div class="register-title">用户注册</div>
            <div class="register-account">
                <el-form :model="registerForm" :rules="registerRules" ref="registerRef" label-width="80px"
                    label-position="right" show-message>
                    <el-form-item label="用户名" prop="username"><el-input v-model="registerForm.username"
                            placeholder="请输入用户名"></el-input></el-form-item>
                    <el-form-item label="密码" prop="password"><el-input v-model="registerForm.password" placeholder="请输入密码"
                            type="password"></el-input></el-form-item>
                    <el-form-item label="确认密码" prop="checkPass">
                        <el-input v-model="registerForm.checkPass" placeholder="请输入确认密码" type="password"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="code">
                        <el-input v-model="registerForm.code" placeholder="请输入验证码" maxlength="4">
                            <template slot="append">
                                <img :src="captcha.img" mode class="captcha" @click="getCode" />
                            </template>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div class="xy" @click="check">
                    <div class="xy-wrap">
                        <div class="iconfont" :class="ischecked ? 'iconxuanze-duoxuan' : 'iconxuanze'"></div>
                        <div class="content">
                            阅读并同意
                            <b @click.stop="getAggrement">《服务协议》</b>
                            与
                            <b @click.stop="getAggrement1">《隐私政策》</b>
                        </div>
                    </div>
                    <div class="toLogin"></div>
                </div>
                <div class="xy" @click="check">
                    <div class="xy-wrap"></div>
                    <div class="toLogin" @click="toLogin">已有账号，立即登录</div>
                </div>
                <el-button @click="register">立即注册</el-button>
            </div>
            <el-dialog title="服务协议" :visible.sync="aggrementVisible" width="60%" :before-close="aggrementClose"
                :lock-scroll="false" center>
                <!-- <div v-html="content" class="xyContent"></div> -->
                <div v-html="content" class="xyContent">

                </div>
            </el-dialog>
            <el-dialog title="隐私政策" :visible.sync="aggrementVisible1" width="60%" :before-close="aggrementClose1"
                :lock-scroll="false" center>
                <div v-html="content1" class="xyContent"></div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getRegisiterAggrement, register, registerConfig } from '@/api/auth/register';
import { captcha } from '@/api/website';
export default {
    name: 'register',
    components: {},
    data() {
        var checkPassValidata = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.registerForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        let self = this;
        var passwordValidata = function (rule, value, callback) {
            let regConfig = self.registerConfig;
            if (!value) {
                return callback(new Error('请输入密码'));
            } else {
                if (regConfig.pwd_len > 0) {
                    if (value.length < regConfig.pwd_len) {
                        return callback(new Error('密码长度不能小于' + regConfig.pwd_len + '位'));
                    } else {
                        callback();
                    }
                } else {
                    if (regConfig.pwd_complexity != '') {
                        let passwordErrorMsg = '密码需包含',
                            reg = '';
                        if (regConfig.pwd_complexity.indexOf('number') != -1) {
                            reg += '(?=.*?[0-9])';
                            passwordErrorMsg += '数字';
                        } else if (regConfig.pwd_complexity.indexOf('letter') != -1) {
                            reg += '(?=.*?[a-z])';
                            passwordErrorMsg += '、小写字母';
                        } else if (regConfig.pwd_complexity.indexOf('upper_case') != -1) {
                            reg += '(?=.*?[A-Z])';
                            passwordErrorMsg += '、大写字母';
                        } else if (regConfig.pwd_complexity.indexOf('symbol') != -1) {
                            reg += '(?=.*?[#?!@$%^&*-])';
                            passwordErrorMsg += '、特殊字符';
                        } else {
                            reg += '';
                            passwordErrorMsg += '';
                        }

                        if (reg.test(value)) {
                            return callback(new Error(passwordErrorMsg));
                        } else {
                            callback();
                        }
                    }
                }
            }
        };
        return {
            registerForm: {
                username: '',
                password: '',
                checkPass: '',
                code: ''
            },
            registerRules: {
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                password: [
                    {
                        required: true,
                        validator: passwordValidata,
                        trigger: 'blur'
                    }
                ],
                checkPass: [{ required: true, validator: checkPassValidata, trigger: 'blur' }],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            ischecked: false,
            agreement: '',
            aggrementVisible: false,
            aggrementVisible1: false,
            captcha: {
                // 验证码
                id: '',
                img: ''
            },
            registerConfig: {},
            content: `<div class="agreementpreview agr-content">
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">欢迎您签署《热付通平台服务协议》（下称“本协议”）并使用热付通平台服务！</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【审慎阅读】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。
                    <strong>
                        <span style="text-decoration:underline;">请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。</span>
                    </strong>
                    如您对协议有任何疑问，可向热付通平台客服咨询。
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【签约动作】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与热付通达成一致，成为热付通平台“用户”。
                    <strong>
                        <span style="text-decoration:underline;">阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">一、定义</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">热付通平台</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">：指包括热付通网站及客户端。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">热付通平台服务</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">：热付通基于互联网，以包含热付通平台网站、客户端等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。</span>
            </p>
			<p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">二、协议范围</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">2.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">签约主体</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【平等主体】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">本协议由您与热付通平台经营者共同缔结，本协议对您与热付通平台经营者均具有合同效力。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【主体信息】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    热付通平台经营者是指经营热付通平台的各法律主体。本协议项下，
                    <strong>
                        <span style="text-decoration:underline;">热付通平台经营者可能根据热付通平台的业务调整而发生变更，变更后的热付通平台经营者与您共同履行本协议并向您提供服务，热付通平台经营者的变更不会影响您本协议项下的权益。热付通平台经营者还有可能因为提供新的热付通平台服务而新增，如您使用新增的热付通平台服务的，视为您同意新增的热付通平台经营者与您共同履行本协议。发生争议时，您可根据您具体使用的服务及对您权益产生影响的具体行为对象确定与您履约的主体及争议相对方。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">三、账户注册与使用</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">3.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">用户资格</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您确认，在您开始注册程序使用热付通平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。
                    <strong>
                        <span style="text-decoration:underline;">若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">此外，您还需确保您不是任何国家、地区或国际组织实施的贸易限制、经济制裁或其他法律法规限制的对象，也未直接或间接为前述对象提供资金、商品或服务，否则您应当停止使用热付通平台服务，同时，您理解违反前述要求可能会造成您无法正常注册及使用热付通平台服务。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">3.2 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">账户说明</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【账户获得】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得热付通平台账户并成为热付通平台用户。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    热付通平台只允许每位用户使用一个热付通平台账户。
                    <strong>
                        <span style="text-decoration:underline;">如有证据证明或热付通根据热付通平台规则判断您存在不当注册或不当使用多个热付通平台账户的情形，热付通平台可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给热付通平台及相关方造成损失的，您还应承担赔偿责任。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【账户使用】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您有权使用您设置或确认的热付通会员名、邮箱、手机号码（以下简称“账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录热付通平台。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您有权使用您的热付通平台账户登录热付通平台，但您的热付通平台账户于2013年3月18日前注册或者您注册热付通平台账户时所使用的邮箱或手机号码已在热付通平台注册或使用过的除外。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">由于您的热付通平台账户关联您的个人信息及热付通平台商业信息，您的热付通平台账户仅限您本人使用。未经热付通平台同意，您直接或间接授权第三方使用您热付通平台账户或获取您账户项下信息的行为无效。如热付通根据热付通平台规则中约定的违约认定程序及标准判断您热付通平台账户的使用可能危及您的账户安全及/或热付通平台信息安全的，热付通平台可拒绝提供相应服务或终止本协议。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【账户转让】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    由于用户账户关联用户信用信息，仅当有法律明文规定、司法裁定或经热付通同意，并符合热付通平台规则规定的用户账户转让流程的情况下，您可进行账户的转让。您的账户一经转让，该账户项下权利义务一并转移。
                    <strong>
                        <span style="text-decoration:underline;">除此外，您的账户不得以任何方式转让，否则热付通平台有权追究您的违约责任，且由此产生的责任及后果均由您自行承担。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【实名认证】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">作为热付通平台经营者，为使您更好地使用热付通平台的各项服务，保障您的账户安全，热付通可要求您按相关法律法规规定完成实名认证。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">3.3 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">注册信息管理</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">3.3.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">真实合法</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【信息真实】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    在使用热付通平台服务时，您应当按热付通平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便热付通或其他用户与您联系。
                    <strong>
                        <span style="text-decoration:underline;">您了解并同意，您有义务保持您提供信息的真实性及有效性。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【会员名的合法性】<span style="text-decoration:underline;">您设置的热付通会员名不得违反国家法律法规及热付通平台相关规则关于会员名的管理规定，否则热付通可回收您的热付通会员名。</span>
                    </span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">热付通会员名的回收不影响您以邮箱、手机号码登录热付通平台并使用热付通平台服务。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">3.4 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">账户安全规范</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【账户安全保管义务】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您的账户为您自行设置并由您保管，热付通任何时候均不会主动要求您提供您的账户密码。因此，建议您务必保管好您的账户，并确保您在每个上网时段结束时退出登录并以正确步骤离开热付通平台。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，热付通并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【账户行为责任自负】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    除热付通存在过错外，
                    <strong>
                        <span style="text-decoration:underline;">您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【日常维护须知】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    如发现任何未经授权使用您账户登录热付通平台或其他可能导致您账户遭窃、遗失的情况，建议您立即通知热付通，并授权热付通将该信息同步给热付通平台。
                    <strong>
                        <span style="text-decoration:underline;">您理解热付通对您的任何请求采取行动均需要合理时间，且热付通应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除热付通存在法定过错外，热付通不承担责任。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">四、热付通平台服务及规范</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【服务概况】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您有权在热付通平台上享受商品及/或服务的浏览、收藏、购买与评价、交易争议处理、信息交流如问答及分享等服务。热付通提供的服务内容众多，具体您可登录热付通平台浏览。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 13px;font-family:微软雅黑,Microsoft YaHei,宋体,SimSun,黑体, SimHei;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 20px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">商品及/或服务的浏览、收藏</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 13px;font-family:微软雅黑,Microsoft YaHei,宋体,SimSun,黑体, SimHei;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 20px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">在您浏览我们网站或客户端的过程中，热付通为您提供了信息分类、关键词检索、筛选、收藏及关注等功能，以更好地匹配您的需求。您可以对您感兴趣的商品及/或服务进行收藏、添加至购物车，关注您所感兴趣的店铺/品牌等。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.2 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">商品及/或服务的购买与评价</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【商品及/或服务的购买】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    当您在热付通平台购买商品及/或服务时，请您务必仔细确认所购商品的品名、价格、数量、型号、规格、尺寸或服务的时间、内容、限制性要求等重要事项，并在下单时核实您的联系地址、电话、收货人等信息。
                    <strong>
                        <span style="text-decoration:underline;">如您填写的收货人非您本人，则该收货人的行为和意思表示产生的法律后果均由您承担。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您的购买行为应当基于真实的消费需求，不得存在对商品及/或服务实施恶意购买、恶意维权等扰乱热付通平台正常交易秩序的行为。基于维护热付通平台交易秩序及交易安全的需要，
                    <strong>
                        <span style="text-decoration:underline;">热付通发现上述情形时可主动执行关闭相关交易订单等操作。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【评价】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您有权在热付通平台提供的评价系统中对与您达成交易的其他用户商品及/或服务进行评价。您应当理解，您在热付通平台的评价信息是公开的，如您不愿意在评价信息中向公众披露您的身份信息，您有权选择通过匿名形式发表评价内容。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    为确保评价内容能为消费者购物决策提供可靠的依据，反映商品及/或服务的真实情况，您的所有评价行为应遵守热付通平台规则的相关规定，评价内容应当合法、客观、真实，与交易的商品及/或服务具有关联性，且不应包含任何污言秽语、色情低俗、广告信息及法律法规与本协议列明的其他禁止性信息；您不应以不正当方式帮助他人提升信用或利用评价权利对其他用户实施威胁、敲诈勒索。
                    <strong>
                        <span style="text-decoration:underline;">热付通可按照热付通平台规则的相关规定对您实施上述行为所产生的评价信息采取必要处置措施。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.3 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">交易争议处理</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【交易争议处理途径】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您在热付通平台交易过程中与其他用户发生争议的，您或其他用户中任何一方均有权选择以下途径解决：</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（一）与争议相对方自主协商；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）使用热付通平台提供的争议调处服务；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（三）请求消费者协会或者其他依法成立的调解组织调解；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（四）向有关行政部门投诉；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（五）根据与争议相对方达成的仲裁协议（如有）提请仲裁机构仲裁；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（六）向人民法院提起诉讼。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【平台调处服务】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">如您依据热付通平台规则使用热付通平台的争议调处服务，则表示您认可并愿意履行热付通平台的客服或大众评审员（“调处方”）作为独立的第三方根据其所了解到的争议事实并依据热付通平台规则所作出的调处决定（包括调整相关订单的交易状态、判定将争议款项的全部或部分支付给交易一方或双方等）。在热付通平台调处决定作出前，您可选择上述（三）、（四）、（五）、（六）途径（下称“其他争议处理途径”）解决争议以中止热付通平台的争议调处服务。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">如您对调处决定不满意，您仍有权采取其他争议处理途径解决争议，但通过其他争议处理途径未取得终局决定前，您仍应先履行调处决定。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.4 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">信息交流</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 13px;font-family:微软雅黑,Microsoft YaHei,宋体,SimSun,黑体, SimHei;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 20px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">为满足用户间分享购物心得等信息交流需求，您可通过热付通提供的问答、晒单分享、论坛、群组及其他信息发布功能进行评论、回复、留言、弹幕、点赞等公开发布信息及与其他用户互动，信息的形式包括文字、图片、视频、直播内容、表情、符号等，您须确保您所发布的所有信息均符合相关法律法规及本协议的要求。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.5 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">贸易限制</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    针对通过热付通平台取得的商品、服务、软件及技术（包括热付通平台提供的软件及技术），您承诺遵守所有适用的进出口管制、贸易限制与经济制裁相关法律法规。基于维护热付通平台交易秩序及交易安全的需要，如您违反前述承诺的，
                    <strong>
                        <span style="text-decoration:underline;">热付通可在发现上述情形时主动执行关闭相关交易订单及作出账户处置等操作。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.6 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">费用</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">热付通为热付通平台向您提供的服务付出了大量的成本，除热付通平台明示的收费业务外，热付通向您提供的服务目前是免费的。如未来热付通向您收取合理费用，热付通会采取合理途径并以足够合理的期限提前通过法定程序并以本协议第八条约定的方式通知您，确保您有充分选择的权利。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">4.7 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">责任限制</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【不可抗力及第三方原因】<span style="text-decoration:underline;">热付通依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，热付通并不承担相应的违约责任：</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）因电力供应故障、通讯网络故障等公共服务因素或第三人因素；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（三）在热付通已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【海量信息】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    热付通仅向您提供热付通平台服务，您了解热付通平台上的信息系用户自行发布，且可能存在风险和瑕疵。热付通将通过依法建立相关检查监控制度尽可能保障您在热付通平台上的合法权益及良好体验。同时，
                    <strong>
                        <span style="text-decoration:underline;">鉴于热付通平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，热付通无法逐一审查商品及/或服务的信息，无法逐一审查交易所涉及的商品及/或服务的质量、安全以及合法性、真实性、准确性，对此您应谨慎判断。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【调处决定】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您理解并同意，在争议调处服务中，热付通平台的客服、大众评审员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，
                    <strong>
                        <span style="text-decoration:underline;">除存在故意或重大过失外，调处方对争议调处决定免责。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">五、用户信息的保护及授权</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">5.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">个人信息的保护</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    热付通非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用热付通提供的服务时，您同意热付通按照在热付通平台上公布的隐私权政策收集、存储、使用、披露和保护您的个人信息。
                    <strong>
                        <span style="text-decoration:underline;">如热付通平台网站或客户端未设独立隐私权政策但使用了热付通平台账号登陆相应网站或客户端的，为保护您的隐私权，我们将参照适用热付通网隐私权政策的要求对您的个人信息进行收集、存储、使用、披露和保护。</span>
                    </strong>
                
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">5.2 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">非个人信息的保证与授权</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【信息的发布】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您声明并保证，您对您所发布的信息拥有相应、合法的权利，您所发布的信息及实施的行为均符合相关法律法规、国家强制性标准要求及本协议约定，并且您对您发布的信息负有管理义务，对其中您违反相关法律法规规定及本协议约定的信息应立即删除。否则，
                    <strong>
                        <span style="text-decoration:underline;">热付通可对您发布的信息依法或依本协议进行删除或屏蔽。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【禁止性信息】<span style="text-decoration:underline;">您应当确保您所发布的信息不包含以下内容：</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（一）反对宪法所确定的基本原则的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一，损害国家荣誉和利益的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（三）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（四）煽动民族仇恨、民族歧视，破坏民族团结的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（五）煽动地域歧视、地域仇恨、人群歧视的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（六）破坏国家宗教政策，宣扬邪教和封建迷信的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（七）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（八）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（九）侮辱或者诽谤他人，侵害他人名誉、隐私、肖像、知识产权和其他合法权益的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序的，破坏社会稳定的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十一）对他人进行暴力恐吓、威胁的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十二）可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的，或侵害未成年人合法权益或者损害未成年人身心健康的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十三）侵害他人个人隐私的，未获他人允许，偷拍、偷录他人，侵害他人合法权利的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十四）散布过度营销信息及垃圾信息；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十无）使用本网站常用语言文字以外的其他语言文字评论的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十六）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十七）使用夸张标题，内容与标题严重不符的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十八）炒作绯闻、丑闻、劣迹等的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（十九）不当评述自然灾害、重大事故等灾难的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二十）宣扬低俗、庸俗、媚俗内容的或宣扬拜金炫富等不良内容的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二十一）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：自杀自残暴力行为的；威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二十三）冒充他人或利用他人的名义使用热付通软件服务或传播任何信息，恶意使用注册账号导致其他用户误认的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二十四）存在可能破坏、篡改、删除、影响热付通平台任何系统正常运行或未经授权秘密获取热付通平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二十五）其他对网络生态造成不良影响的内容，及法律、行政法规禁止的其他内容。</span>
                    </span>
                </strong>
            </p>
            
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">六、用户的违约及处理</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">6.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">违约认定</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">发生如下情形之一的，视为您违约：</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（一）使用热付通平台服务时违反有关法律法规规定的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）违反本协议或本协议补充协议（即本协议第2.2条）约定的。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    为适应电子商务发展和满足海量用户对高效优质服务的需求，您理解并同意，
                    <strong>
                        <span style="text-decoration:underline;">热付通可在热付通平台规则中约定违约认定的程序和标准。如：热付通可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">6.2 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">违约处理措施</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【信息处理】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您在热付通平台上发布的信息构成违约的，
                    <strong>
                        <span style="text-decoration:underline;">热付通可根据相应规则立即对相应信息进行删除、屏蔽处理。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【行为限制】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    您在热付通平台上实施的行为，或虽未在热付通平台上实施但对热付通平台及其用户产生影响的行为构成违约的，热付通
                    <strong>
                        <span style="text-decoration:underline;">可依据相应规则对您执行账户扣分、中止向您提供部分或全部服务、划扣违约金等处理措施。如您的行为构成根本违约的，热付通可查封您的账户，终止向您提供服务。</span>
                    </strong>
                </span>
            </p>
           
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【处理结果公示】<span style="text-decoration:underline;">热付通可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在热付通平台上予以公示。</span>
                    </span>
                </strong>
            </p>
          
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong> <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">6.3 &nbsp;</span></strong>
                <strong><span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">特别约定</span></strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【商业贿赂】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                    如您向热付通的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。
                    <strong>
                        <span style="text-decoration:underline;">发生上述情形的，热付通可立即终止与您的所有合作并向您收取违约金及/或赔偿金</span>
                    </strong>
                    ，该等金额以热付通因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【关联处理】<span style="text-decoration:underline;">如您因严重违约导致热付通终止本协议时，出于维护平台秩序及保护消费者权益的目的，热付通可对与您在其他协议项下的合作采取中止甚或终止协议的措施，并以本协议第八条约定的方式通知您。</span>
                    </span>
                </strong>
            </p>

            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">七、协议的变更</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">热付通可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过法定程序并以本协议第八条约定的方式通知您。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">如您不同意变更事项，您有权于变更事项确定的生效日前联系热付通反馈意见。如反馈意见得以采纳，热付通将酌情调整变更事项。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用热付通平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用热付通平台服务，则视为您同意已生效的变更事项。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">八、通知</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">8.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">有效联系方式</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您在注册成为热付通平台用户，并接受热付通平台服务时，您应该向热付通提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                            您有权通过您注册时填写的手机号码或者电子邮箱获取您感兴趣的商品广告信息、促销优惠等商业性信息；<strong>您如果不愿意接收此类信息，您有权通过热付通提供的相应的退订功能进行退订。</strong>
                        </span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">8.2 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">通知的送达</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">热付通通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在热付通平台公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，向您的账号发送旺旺信息、系统消息以及站内信信息，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">对于在热付通平台上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件或热付通旺旺等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱或热付通旺旺账号等联系方式为您在热付通平台注册、更新时提供的手机号码、电子邮箱联系方式以及在注册热付通用户时生成热付通旺旺账号，司法机关向上述联系方式发出法律文书即视为送达。您指定的邮寄地址为您的法定联系地址或您提供的有效联系地址。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您同意司法机关可采取以上一种或多种送达方式向您达法律文书，司法机关采取多种方式向您送达法律文书，送达时间以上述送达方式中最先送达的为准。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您同意上述送达方式适用于各个司法程序阶段。如进入诉讼程序的，包括但不限于一审、二审、再审、执行以及督促程序等。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="text-decoration:underline;">
                        <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">九、协议的终止</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">9.1 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">终止的情形</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【用户发起的终止】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">您有权通过以下任一方式终止本协议：</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）变更事项生效前您停止使用并明示不愿接受变更事项的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（三）您明示不愿继续使用热付通平台服务，且符合热付通平台终止条件的。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【热付通发起的终止】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">出现以下情况时，热付通可以本协议第八条的所列的方式通知您终止本协议：</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（一）您违反本协议约定，热付通依据违约条款终止本协议的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，热付通依据热付通平台规则对您的账户予以查封的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（三）除上述情形外，因您多次违反热付通平台规则相关规定且情节严重，热付通依据热付通平台规则对您的账户予以查封的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（四）您的账户被热付通依据本协议回收的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（五）您在热付通平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（六）其它应当终止服务的情况。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">9.2 &nbsp;</span>
                </strong>
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">协议终止后的处理</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【用户信息披露】<span style="text-decoration:underline;">本协议终止后，除法律有明确规定外，热付通无义务向您或您指定的第三方披露您账户中的任何信息。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【热付通权利】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">本协议终止后，热付通仍享有下列权利：</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（一）继续保存您留存于热付通平台的本协议第五条所列的各类信息；</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">（二）对于您过往的违约行为，热付通仍可依据本协议向您追究违约责任。</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【交易处理】<span style="text-decoration:underline;">本协议终止后，对于您在本协议存续期间产生的交易订单，热付通可通知交易相对方并根据交易相对方的意愿决定是否关闭该等交易订单；如交易相对方要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px;background-color: white">
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">十、法律适用、管辖与其他</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【法律适用】<span style="text-decoration:underline;">本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例及/或行业惯例。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: medium;font-family:宋体,SimSun;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 24px">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">
                        【管辖】<span style="text-decoration:underline;">您因使用热付通平台服务所产生及与热付通平台服务有关的争议，由热付通与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</span>
                    </span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 13px;font-family:微软雅黑,Microsoft YaHei,宋体,SimSun,黑体, SimHei;caret-color: rgb(0, 0, 0);color: rgb(0, 0, 0);white-space: normal;line-height: 20px;vertical-align: baseline">
                <strong>
                    <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">【可分性】</span>
                </strong>
                <span style="font-size: 12px;line-height: 18px;font-family:微软雅黑,Microsoft YaHei;color: rgb(51, 51, 51)">本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</span>
                <span style="font-size: 14px;line-height: 21px">&nbsp;&nbsp;</span>
            </p>
            <p>
                <br/>
            </p>
        </div>`,
            content1: `<div class="agreementpreview agr-content">
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;text-align: justify;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;text-indent: 28px;">欢迎您使用我们的产品和服务！我们深知个人信息对您的重要性，您的信赖对我们非常重要，我们将严格遵守法律法规要求以合法正当、最小必要的原则，并采取相应的安全保护措施，致力于保护您的个人信息安全可控。基于此，热付通网服务提供者（或简称“我们”）制定本《热付通网基本功能隐私政策》（下称“本政策”/“本隐私政策”），帮助您充分了解在您使用我们产品和服务的过程中，我们会如何收集、使用、共享、存储和保护您的个人信息以及您可以如何管理您的个人信息，以便您更好地作出适当的选择。</span>
            </p>
            <p style="text-indent: 0px; margin: 0px 13px 0px 0px; font-size: 16px; font-family: 宋体, SimSun;text-indent: 28px; color: rgb(0, 0, 0); text-wrap: wrap; text-align: justify; line-height: 32px;">
                <span style="text-indent: 28px; background-color: rgb(255, 255, 255); font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;text-indent: 28px;">在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体/粗体下划线标识的条款，确保您充分理解和同意之后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。</span>
                <span style="text-indent: 28px; background-color: rgb(255, 255, 255); font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline;">
                    <strong>如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。</strong>
                </span>
            </p>
            <p style="text-indent: 0px; margin: 0px 13px 0px 0px; font-size: 16px; font-family: 宋体, SimSun; color: rgb(0, 0, 0); text-wrap: wrap; text-indent: 28px;text-align: justify; line-height: 32px;">
                <span style="text-decoration: underline;">
                    <strong style="text-indent: 28px;">
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">您同意隐私政策表示您已了解我们产品和服务所提供的基本功能，以及基本功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能，涉及附加功能的开启我们会根据您的实际使用情况单独征求您的同意。如果您拒绝开启附加功能和我们收集非必要个人信息，并不会影响您使用基本功能。</span>
                    </strong>
                </span>
            </p>

            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;background-color: white">&nbsp;</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">一、适用范围</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">本政策适用于热付通网服务提供者以网站、客户端以及随技术发展出现的新形态向您提供的各项网上购物基本功能的产品和服务。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">除本政策说明的相关信息收集使用活动外，本政策不适用于热付通网卖家及其他第三方向您提供的其他服务，其他服务适用其向您另行说明的个人信息收集使用规则。例如，当您加入卖家或品牌的会员时，则此类卖家或品牌对会员信息的使用适用其专门向您说明的规则。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;background-color: white">&nbsp;</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">二、信息收集及使用</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">&nbsp;为实现向您提供我们产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。</span>
                <span style="font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline;">
                    <strong>如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务。</strong>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们会为您提供的各项具体功能场景包括：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（一）帮助您成为我们的会员及账户管理</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、热付通平台账户服务</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    我们基于热付通平台账户为您提供服务。为了创建热付通平台账户您需要至少向我们提供您的<strong>手机号码、拟使用的会员名和密码</strong>
                    。如果您拒绝提供上述信息，您将无法注册热付通平台账户，仅可以使用浏览、搜索服务。我们会根据您的热付通平台账户使用情况及平台设置的账户等级计算规则确定您当前的等级，并为您提供相应账户等级所对应的基本权益。
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">您可通过热付通平台账户在我们网站或者客户端提供的链接入口或其他产品/服务入口使用我们及/或关联公司提供的产品或服务。为方便您管理热付通平台账户，我们会在热付通平台账户服务中同步并显示您的注册信息，以及您在热付通平台上或与热付通平台账户相关联的产品和服务中执行的操作，包括通过热付通平台账户集中展示您的个人资料、优惠权益、交易订单。您热付通平台账户所关联的上述信息，将会被用于为您提供客户服务，识别账号安全风险，以及推荐您可能感兴趣的商品或服务信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、授权登录</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们可能经您单独同意后向第三方提供您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或第三方处直接登录。此外，我们可能会根据您的单独同意从第三方处获取您的第三方账户信息，并与您的热付通平台账户进行绑定，使您可在第三方处直接登录、使用我们的产品及/或服务。我们将在您单独同意的授权范围内使用您的相关信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、身份验证</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为满足相关法律规定及监管要求、确保用户身份真实性、实现反欺诈等风险控制、保障系统和服务安全，在您使用特定服务/功能时，我们需要收集您的相关信息进行身份验证，如：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    【找回账号】当您使用“找回热付通账号”、“找回密码”等功能时，我们可能会收集您的身份信息，包括您的<strong>真实姓名、身份证件号码</strong>
                    ，或其他能够证明的信息（如邮箱等），用于证实您的身份，帮您找回热付通平台账户。
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（二）向您展示商品或服务信息</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、&nbsp;浏览</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">当您浏览热付通网时，您可以选择对感兴趣的商品、店铺、频道、直播间、内容（及内容创作者进行收藏/订阅/添加/关注/分享/点赞操作，我们会收集您的操作记录用于实现前述功能及其他我们明确告知的目的。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、&nbsp;搜索</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    当您使用搜索功能（包括图片、语音搜索）时，我们会收集您的搜索记录，包括搜索内容（搜索词、图片、语音信息）、浏览记录/时间、搜索时间/次数               。
                </span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为了提供高效的搜索服务，部分前述信息会暂时存储在您的本地设备端，并向您展示搜索历史记录。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、&nbsp;个性化推荐</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">为向您展示和推荐您可能感兴趣的商品或服务信息，我们会收集和使用您在访问或使用热付通平台网站或客户端时的浏览、搜索、加购、交易记录并结合依法收集的设备信息、服务日志信息以及其他取得您授权的信息，通过算法模型预测您的偏好特征。我们会基于您的偏好特征在热付通及其他第三方应用程序或终端向您推送您可能感兴趣的商业广告及其他信息，或者向您发送商业性信息。我们还会基于对热付通平台用户浏览、搜索商品或服务的热点、潮流与趋势的统计分析，使用排序精选类算法形成相关精选的榜单，并向您进行推荐。</span>
                    </strong>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">个性化推荐与检索类算法会基于模型预测您的偏好特征，匹配您可能感兴趣的商品、服务或其他信息，对向您展示的商品、服务或其他信息进行排序。我们会根据您使用产品过程中的浏览行为，对推荐模型进行实时反馈，不断调整优化推荐结果。为满足您的多元需求，我们会在排序过程中引入多样化推荐技术，拓展推荐的内容，避免同类型内容过度集中。</span>
                    </strong>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">同时，我们通过以下措施努力保障您的隐私体验：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1、如您不想接受我们给您发送的广告或商业性信息，您可通过短信、邮件或电话回复退订或通过客服等我们提供的其他方式进行退订或关闭；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2、如您在使用我们提供的站内搜索服务时，需要查看不针对您个人特征的排序，您可以在搜索结果页面点击”筛选”，选择其中的“通用排序”进行设置；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3、如您不想看到我们在首页或进入支付完成页面给您推荐的商品或服务，您可以通过长按被推荐的商品或服务图片，在随后出现的弹窗中根据提示选择屏蔽类似商品或者商品或服务所属的类目；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（三）帮助您完成交易</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">购物车</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">当您使用购物车功能时，我们会收集您对商品的加购信息，并会使用您的订单信息以优化您的购物体验（如进行降价/优惠提醒、常购商品的筛选、特定购物车分享链接的推荐等）。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">下单及订单管理</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    当您在我们的产品及/或服务中订购具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,您需至少提供您的<strong>收货人姓名、收货地址、收货人联系电话，</strong>
                    对于部分特殊类型的商品和服务您还需要提供该商品或服务所必需的其他信息。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    同时该订单中会载明您所购买的商品及/或服务信息、具体订单号、订单创建时间、您已使用的优惠、应支付的金额、您的备注信息。<span style=";background-color: white">我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、便于您查询订单信息、提供客服与售后服务、进行对账以及优惠信息对应的税务申报（如需）及其他我们明确告知的目的。</span>
                </span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">您可以通过热付通网为其他人订购商品及/或服务，</span>
                <span style="font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline;">
                    <strong>您需要提供该实际收货人的前述个人信息，并确保已取得该实际收货人的同意。</strong>
                </span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为便于您了解、查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">您可以通过“我的订单”查看和管理您的订单信息。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">商品或服务的支付与交付</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">当您购买商品或服务时，为了帮助您完成或代他人完成订单支付，并顺利收取所购买的商品或服务，我们或提供服务的第三方会收集您的订单信息、配送信息。具体内容请参见本政策“三、数据使用过程中涉及的合作方及转移、公开个人信息”。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（四）为您提供信息发布功能</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、&nbsp;&nbsp;评价、评论</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">当您对交易的商品及/或服务进行评价时，我们会收集并在店铺“宝贝评价”列表、晒单等店铺页面及/或热付通首页、逛逛等公共页面展示您的评价和分享内容（包括您发布的文字、图片、视频等）、头像、昵称。如您选择匿名评价，您的头像、昵称不会对外展示且评价内容不会在公共页面展示。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">当您对其他用户发布的评价、内容进行评论时，您的头像、昵称及评论内容将公开展示。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">您可向已购买用户提问，同时当您作为已购买用户时，您可能会收到系统随机推送的对其他用户提问进行回答的邀请，当您选择提问、回答时，您的问答内容及头像将公开展示。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; background-color: white;">请注意，您使用信息发布功能可能会涉及您或他人的个人信息甚至敏感个人信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及他人个人信息的，您需在发布前征得他人的同意。</span>
                    </strong>
                </span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;background-color: white">（五）通知及互动交流</span>
                </strong>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、</span>
                </strong>
                                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;background-color: white">消息通知</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们在运营中可能会通过您在使用产品及/或服务的过程中所提供的联系方式（如联系电话、联系邮箱），向您同时发送一种或多种类型的通知，例如服务通知、身份验证、安全验证、用户使用体验调研等。我们也可能会以短信、弹窗推送的方式向您发送您可能感兴趣的服务、功能或活动的商业性信息及其他商品或服务信息。如您不愿接收我们的商业性信息及其他商品或服务信息，您可以通过短信、电话、邮件中提供的退订方式或通过我们的客服进行退订或关闭，如您希望关闭弹窗推送信息，您可以在您的设备“设置”中选择开启/关闭热付通的通知权限。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">此外，当您主动发起客服咨询或与店铺发生交易、进行互动（如订阅、加入店铺会员）等，您将会在“消息”中收到店铺的客服消息，您可以进入相应店铺的聊天页面进行免打扰设置。</span>
            </p>
            <p style="margin: 0 9px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;background-color: white">活动参与</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    当您参与我们举办的活动时，我们可能需要收集及使用您的相关个人信息（包括但不限于您的昵称、头像、<strong>联系方式、收货信息</strong>
                    、订单信息、浏览记录、账户等级），以帮助您实现活动报名、参与、享受活动权益、抽奖、兑奖等，请您关注在相关场景向您另行告知的具体个人信息收集及使用范围，并在同意后参与相应的活动。
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">如相关活动由我们与关联公司或第三方联合举办的，我们会在获取您的同意后与该关联方或第三方共享必要信息，或将您热付通账号与关联公司或第三方平台账号进行绑定，及/或在多个参与活动平台之间同步您参与活动的账户、参与进度、享受到的具体权益等信息，以保障您在活动中获得一致、完整的服务。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（六）客服及争议处理</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">当您与我们联系或提出售中、售后、争议纠纷处理申请时，为了保障您的账户及系统安全，</span>
                <span style="font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline;">
                    <strong>我们需要您提供必要的个人信息以核验您的会员身份。</strong>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的沟通、通信/通话记录及相关内容（包括账户信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息）。如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账户信息和订单信息。</span>
                    </strong>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们将使用深度学习技术为您提供智能问答对话、智能语音客服服务。对您与我们沟通、通信/通话记录及相关内容进行去标识化处理，在无法识别您身份的情况下，将其用于智能客服算法模型训练。在您接受智能客服服务期间，我们会对您进行显著的提示。我们会基于您的智能客服使用记录，不断改进智能客服的服务质量。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;background-color: white">&nbsp;</span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">三、数据使用过程中涉及的合作方及转移、公开个人信息</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（一）数据使用过程中涉及的合作方</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、基本原则</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们与合作方合作时，将遵守以下原则：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    （1）&nbsp;&nbsp;&nbsp;<strong>合法正当与最小必要原则：</strong>
                    数据处理应当具有合法性基础，具有正当的目的，并以实现处理目的最小范围为限。
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    （2）&nbsp;&nbsp;<strong>用户知情权与决定权最大化原则：</strong>
                    数据处理过程中充分尊重用户对其个人信息处理享有的知情权与决定权。
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    （3）&nbsp;&nbsp;<strong>安全保障能力最强化原则：</strong>
                    我们将采取必要措施保障所处理个人信息的安全，审慎评估合作方使用数据的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作协议的有关要求。
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、合作方的范围</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">若具体功能和场景中涉及由我们的关联方、第三方提供服务，则合作方范围包括我们的关联方与第三方。</span>
            </p>
            <p style="margin: 0 13px 0 28px;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、委托处理</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们可能委托授权合作方处理您的个人信息，以便授权合作方代表我们为您提供某些服务或履行职能。我们仅会出于本政策声明的合法、正当、必要、特定、明确的目的委托其处理您的信息，授权合作方只能接触到其履行职责所需信息，且我们将会通过协议要求其不得将此信息用于其他任何超出委托范围的目的。如果授权合作方将您的信息用于我们未委托的用途，其将单独征得您的同意。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">4</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、共同处理</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">对于共同处理个人信息的场景，我们会与合作方根据法律规定签署相关协议并约定各自的权利和义务，确保在使用相关个人信息的过程中遵守法律的相关规定、保护数据安全。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">5</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、合作场景</span>
                </strong>
            </p>
          
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为保证您购买的商品及/或服务能够顺利、安全、准确送达、提供，我们会向为热付通平台提供物流信息系统和技术服务的浙江菜鸟供应链管理有限公司披露订单相关的配送信息，并由其根据商品及/或服务提供主体的选择向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为向您提供售后与争议解决服务之目的，我们需要及时获悉并确认交付进度及状态，您同意我们可自物流相关服务主体处收集与交付进度相关的信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（2）</span>
                </strong>
                                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">广告与分析服务</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们会在采用行业通用的安全技术前提下，委托合作方处理与广告投放、覆盖面和有效性相关的信息。我们不会将您的个人身份信息委托合作方处理。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（3）</span>
                </strong>
                                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">安全与统计分析</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">A</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">．保障使用安全：</span>
                </strong>
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们非常重视产品及/或服务的安全性，为保障用户的正当合法权益免受不法侵害，我们委托处理的合作方可能会使用严格去标识化且无法反推特定个人的必要的设备、账号及日志信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">B.</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">分析产品情况：</span>
                </strong>
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为分析产品及/或服务的稳定性，提供分析服务的合作方可能需要使用服务情况、设备标识信息、应用总体安装使用情况等信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">C.</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">学术科研</span>
                </strong>
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与合作方（如科研院所、高校等机构）使用去标识化或匿名化的数据。</span>
            </p>
            <p class="MsoListParagraph" style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（4）</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">其他合作场景</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">除上述合作场景外，我们还可能会将信息委托给支持我们业务的其他合作方处理，包括受我们委托提供技术基础设施服务、分析我们服务的使用方式、提供商家会员服务或者其他客户服务。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作方的SDK或其他类似的应用程序。我们会对授权合作方获取有关信息的应用程序接口（API）、SDK进行严格的安全检测，并与授权合作方约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。授权合作方单独取得您同意的除外。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（二）转移</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式。接收方将继续履行本政策及其他法定义务。接收方变更原先的处理目的、处理方式的，会重新取得您的同意。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（三）公开披露</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们仅会在以下情况下，公开披露您的个人信息：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1、基于您的主动选择及其他单独同意的情况下，我们可能会公开披露您的个人信息；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2、</span>
                <span style="font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;; text-decoration: underline;">
                    <strong>如果我们确定您出现违反法律法规或严重违反热付通平台相关协议及规则的情况，或为保护热付通平台用户或公众的人身财产安全免遭侵害，我们可能披露关于您的个人信息，</strong>
                </span>
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">
                    包括相关违规行为以及热付通平台已对您采取的措施。<br/>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（四）停止运营</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">如果我们停止运营产品</span>
                    </strong>
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">及/或</span>
                    </strong>
                    <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">
                        <strong>服务，将及时停止继续收集您的个人信息。我们会逐一送达通知或以公告的形式向您发送停止运营的告知，并对我们所持有的与已关停的产品</strong>
                        及/或<strong>服务相关的个人信息按照本隐私政策【信息的存储-存储期限】和【您的权利-删除】中的方式进行删除或匿名化处理。</strong>
                    </span>
                </span>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>

                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（五）依法豁免征得您的授权同意的情形</span>
                </strong>
            </p>
            <p style="margin: 0 13px 0 0;font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">请您理解，在下列情形中，根据法律法规及国家标准，合作方使用，或我们转移、公开您的个人信息无需征得您的授权同意：</span>
                    </strong>
                </span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1、&nbsp;&nbsp;&nbsp;根据您的要求订立或履行合同所必需：您通过热付通平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者或者热付通平台上相关服务市场的运营者，以实现您的交易、配送及售后服务需求。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2、&nbsp;&nbsp;&nbsp;为履行法定职责或者法定义务所必需：我们可能会根据法律法规规定、诉讼、争议解决的必要，或按行政、司法、监察等有权机关依法提出的要求，以及其他法定义务履行的必需，共享您的个人信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3、&nbsp;&nbsp;&nbsp;为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">4、&nbsp;&nbsp;&nbsp;为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">5、&nbsp;&nbsp;&nbsp;在合理的范围内处理您自行公开的个人信息，或者其他已经合法公开的个人信息（如合法的新闻报道、政府信息公开等渠道合法公开的个人信息）。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">6、&nbsp;&nbsp;&nbsp;法律法规规定的其他情形。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px"></br>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">四、信息的存储</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（一）存储期限</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="text-decoration: underline;">
                    <strong>
                        <span style="text-decoration: underline; font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;">我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，</span>
                    </strong>
                </span>
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们判断个人信息的存储期限主要依据以下标准：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1、完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2、保证我们为您提供服务的安全和质量；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3、您是否同意更长的留存期间；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">4、根据诉讼时效的相关需要；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">5、是否存在关于保留期限的其他特别约定或法律法规规定。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">在超出保留期间后，我们会根据适用法律的要求删除或匿名化处理您的个人信息。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（二）存储位置</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">原则上，我们在中华人民共和国境内收集和产生的个人信息，根据适用法律的要求存储在境内。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">（三）存储安全</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、数据保护技术措施</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，我们会使用加密技术提高个人信息的安全性，在您的浏览器与服务器之间交换数据时受 &nbsp;SSL协议加密保护，我们提供HTTPS协议安全浏览方式；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息。目前，我们的重要信息系统已经通过网络安全等级保护的三级以上测评。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、数据保护管理组织措施</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们建立了行业内先进的以数据为核心、围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理及产品技术的维度提升个人信息的安全性。我们已经设置了个人信息保护专职部门，并指定了专人负责儿童个人信息保护。我们通过培训课程和考试，不断加强员工对于保护个人信息重要性的认识。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3</span>
                </strong>
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、个人信息安全事件的响应</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们会及时启动应急预案，采取合理必要的措施，以尽可能降低对您个人的影响。如发生个人信息安全事件，我们还将按照法律法规的要求向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将以短信、电话、推送通知及其他合理渠道告知您，难以逐一告知的，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <strong> <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">4</span>                </strong>
                <strong>  <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">、账户安全风险的防范</span>                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">在使用热付通网服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。此外，您也可以通过我们的服务与第三方建立沟通、交流信息或分析内容。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供，不轻信通过其他交易工具进行交易，以免信息被窃取甚至遭遇电信网络诈骗。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">如您担心自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络热付通网客服或</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px"></br>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">五、政策的更新</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">为给您带来更好的产品和服务体验，我们持续努力改进我们的产品、服务及技术。在新的服务及业务流程变更时，我们可能会更新我们的隐私政策以告知您具体的变化。但未经您明确同意，我们不会限制您按照本政策所享有的权利。我们会在</span>              
                    <em>
                        <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;color: black">专门页面</span>
                    </em>         
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">上发布对本政策所做的任何变更。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">对于重大变更，我们还会提供更为显著的通知（包括我们会通过热付通网公示的方式进行通知或向您提供弹窗提示）。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">本政策所指的重大变更包括但不限于：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">1、产品的业务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">2、业务调整、交易并购引起的隐私政策的主体变更，新主体接收方变更原先的处理目的、处理方式；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">3、个人信息共享或公开披露的主要对象发生变化；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">4、用户个人信息权利及其行使方式发生重大变化；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">5、处理个人信息保护负责人的联络方式及投诉渠道发生变化时；</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">6、个人信息保护影响评估报告表明产品存在对个人权益有重大影响时。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">我们还会将本政策的旧版本在</span>
                <em><span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;color: black">热付通网专门页面</span>                    </em>
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">存档，供您查阅。</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px"></br>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;line-height: 32px">
                <strong>
                    <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">六、联系我们</span>
                </strong>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：</span>
            </p>
            <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">联系电话：400-024-2181</span>
            </p> <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">联系邮箱：brxm@heatingpay.com</span>
            </p> <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">注册地址：河北省保定市安新县建设大街220号卓凯盛鑫孵化基地2018室</span>
            </p> <p style=";font-size: 16px;font-family:宋体,SimSun;color: rgb(0, 0, 0);text-wrap: wrap;text-align: justify;text-indent: 28px;line-height: 32px">
                <span style="font-size: 14px;font-family:微软雅黑,Microsoft YaHei;">常用办公地址：河北省保定市安新县建设大街220号卓凯盛鑫孵化基地2018室</span>
            </p>
        </div>`
        };
    },
    created() {
        this.getCode();
        this.regisiterAggrement();
        this.getRegisterConfig();
    },
    methods: {
        check() {
            this.ischecked = !this.ischecked;
        },
        toLogin() {
            this.$router.push('/login');
        },
        //  获取注册配置
        getRegisterConfig() {
            registerConfig()
                .then(res => {
                    if (res.code >= 0) {
                        this.registerConfig = res.data.value;
                        if (this.registerConfig.is_enable != 1) {
                            this.$message({
                                message: '平台未启用注册',
                                type: 'warning',
                                duration: 2000,
                                onClose: () => {
                                    this.$router.push('/');
                                }
                            });
                        }
                    }
                })
                .catch(err => {
                    console.log(err.message)
                });
        },
        // 注册
        register() {
            this.$refs.registerRef.validate(valid => {
                if (valid) {
                    if (!this.ischecked) {
                        return this.$message({
                            message: '请先阅读协议并勾选',
                            type: 'warning'
                        });
                    }
                    var data = {
                        username: this.registerForm.username.trim(),
                        password: this.registerForm.password
                    };
                    if (this.captcha.id != '') {
                        data.captcha_id = this.captcha.id;
                        data.captcha_code = this.registerForm.code;
                    }
                    this.$store
                        .dispatch('member/register_token', data)
                        .then(res => {
                            if (res.code >= 0) {
                                this.$router.push('/member/index');
                            }
                        })
                        .catch(err => {
                            this.$message.error(err.message);
                            this.getCode();
                        });
                } else {
                    return false;
                }
            });
        },
        aggrementClose() {
            this.aggrementVisible = false;
        },
        aggrementClose1() {
            this.aggrementVisible1 = false;
        },
        // 获取协议
        regisiterAggrement() {
            getRegisiterAggrement()
                .then(res => {
                    if (res.code >= 0) {
                        this.agreement = res.data;
                    }
                })
                .catch(err => {
                    console.log(err.message)
                });
        },
        getAggrement() {
            this.aggrementVisible = true;
        },
        getAggrement1() {
            this.aggrementVisible1 = true;
        },
        // 获取验证码
        getCode() {
            captcha({ captcha_id: 'this.captcha.id' })
                .then(res => {
                    if (res.code >= 0) {
                        this.captcha = res.data;
                        this.captcha.img = this.captcha.img.replace(/\r\n/g, '');
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.register {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
}

.box-card {
    width: 500px;
    margin: 0 auto;
    display: flex;
    background-color: #ffffff;
    padding: 0 30px 30px 30px;
    flex-direction: column;

    .register-title {
        border-bottom: 1px solid #f1f1f1;
        text-align: left;
        margin-bottom: 20px;
        font-size: 16px;
        color: $base-color;
        padding: 10px 0;
    }

    .register-account {
        width: 100%;
        text-align: center;
    }

    .code {
        width: 80%;
        text-align: left;
    }

    .el-form {
        margin: 0 30px;

        .captcha {
            vertical-align: top;
            max-width: inherit;
            max-height: 38px;
            line-height: 38px;
            cursor: pointer;
        }
    }

    .xyContent {
        height: 600px;
        overflow-y: scroll;
    }

    .xy {
        margin-left: 110px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-align: left;
        margin-right: 30px;

        .toLogin {
            cursor: pointer;
        }

        .xy-wrap {
            display: flex;
            align-items: center;
            font-size: $ns-font-size-base;
            cursor: pointer;

            .iconfont {
                display: flex;
                align-content: center;
            }

            .content {
                margin-left: 3px;

                b {
                    color: $base-color;
                }
            }
        }

        .iconxuanze-duoxuan {
            color: $base-color;
        }
    }

    .el-button {
        margin-top: 20px;
        background-color: $base-color;
        color: #ffffff;
        width: calc(100% - 60px);
    }
}
</style>
